export const Experiment = {
  AshbyIntegration: "20230704_ASHBY_ATS_INTEGRATION",
  NewJobWizard: "20231016_HIRE_APP_NEW_JOB_WIZARD",
  CandidateCount: "20231113_HIRE_APP_CANDIDATE_COUNT",
  NewJobAnalytics: "20240214_NEW_JOB_ANALYTICS",
} as const;
